module.exports = __webpack_public_path__ + "themes/giveandgo/assets/img/full.ecaeb62a.jpg";